





































import { Component, Prop, Vue } from "vue-property-decorator";
import _ from "lodash";
import LabelValue from "@/components/miscellaneous/LabelValue.vue";

export interface GaugePart {
    label: string;
    amount: number;
    color: string;
}

const components = {
    LabelValue,
};

@Component({components})
export default class Gauge extends Vue {
    @Prop(Array) private parts!: GaugePart[];
    @Prop({ type: String, default: "" }) private title!: string;
    @Prop({ type: String, default: "" }) private amountSuffix!: string;

    private get totalAmount() {
        return _.sumBy(this.parts, "amount");
    }

    private get isValid() {
        return _.every(this.parts, (part: GaugePart) => {
            return 0 <= part.amount;
        });
    }

    private getAmount(part: GaugePart) {
        return `${part.amount}${this.amountSuffix}`;
    }

    private innerStyle(part: GaugePart) {
        const percentWidth = part.amount / this.totalAmount * 100;

        return {
            width: `${percentWidth}%`,
            backgroundColor: part.color,
        };
    }
}
